
.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.field-with-text {
  display: flex;
  align-items: center;

  gz-text {
    margin-left: 50px;
    padding-bottom: 20px;
  }
}
